export const smallDescription = (fullDesc, desiredwordLength) => {
  const wordArray = fullDesc?.split(" ");
  const smallDesc =
    wordArray.length > desiredwordLength
      ? wordArray?.slice(0, desiredwordLength).join(" ").concat("...")
      : wordArray?.slice(0, desiredwordLength).join(" ");
  return smallDesc;
};
